export default __webpack_public_path__ + "static/media/FooterBackground.89b60a60.svg";